import { services } from '@fiverr-private/identification_core';

export const signIn = services.signIn;
